import { LogLevel, type Configuration } from '@azure/msal-browser';
import { isInIframe } from '@/lib/embed';

const configuredRedirectUri = import.meta.env.ENTRA_REDIRECT_URI;

export const entraEnabled = import.meta.env.ENTRA_ENABLED === 'true';
export const embedded = isInIframe();

export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.ENTRA_CLIENT_ID ?? '',
    authority: import.meta.env.ENTRA_AUTHORITY,
    redirectUri: configuredRedirectUri || window.location.origin,
    postLogoutRedirectUri: configuredRedirectUri || window.location.origin,
    // Don't navigate the host page back to the login request URL in a frame.
    navigateToLoginRequestUrl: !embedded,
  },
  cache: {
    // localStorage when embedded: shared between the iframe and any popup
    // window, and survives iframe reloads. sessionStorage does NOT share
    // state with popups — the popup would log in but the iframe never sees it.
    cacheLocation: embedded ? 'localStorage' : 'sessionStorage',
    // Survives partitioned/blocked third-party storage in embedded contexts.
    storeAuthStateInCookie: embedded,
  },
  system: {
    // Silences the redirect_in_iframe throw during MSAL's startup redirect
    // processing. It does NOT make loginRedirect work in an iframe — all
    // interactive calls still branch to popups when embedded.
    allowRedirectInIframe: true,
    loggerOptions: { logLevel: LogLevel.Warning, piiLoggingEnabled: false },
  },
};

export const loginRequest = {
  scopes: (import.meta.env.ENTRA_SCOPES || 'openid profile email offline_access User.Read')
    .split(/\s+/)
    .filter(Boolean),
};
